import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Checkbox, SelectInput, TextInput } from 'hosman-material';

import { updateOnboardedUser, updateErrors } from '../../../../../../../../reducers/SellerApp/mandatesSlice';

export const allCoOwnershipKinds = [
  { id: 1, value: 'sci', name: 'SCI' },
  { id: 2, value: 'indivision', name: 'Indivision' },
  { id: 3, value: 'other', name: 'Autre' }
]

const CoOwnershipInput = () => {
  const { onboardedUser, errors } = useSelector((state) => state.sellerMandates);
  const dispatch = useDispatch();

  useEffect(() => {
    if (onboardedUser.co_ownership) return

    dispatch(updateOnboardedUser({ ...onboardedUser, co_ownership: false, co_ownership_kind: null, co_ownership_name: '' }));
  }, [onboardedUser.co_ownership]);

  const handleKindSelect = (option) => {
    dispatch(updateErrors({ ...errors, co_ownership_kind: null }));
    dispatch(updateOnboardedUser({ ...onboardedUser, co_ownership_kind: option.value }));
  }

  const handleNameChange = (e) => {
    dispatch(updateOnboardedUser({ ...onboardedUser, co_ownership_name: e.target.value }))
    dispatch(updateErrors({ ...errors, co_ownership_name: null }));
  }

  return (
    <div className='flex flex-col gap-3' data-testid='CoOwnershipInput'>
      <Checkbox
        label='Je représente une SCI, indivision ou une autre forme de société'
        isChecked={onboardedUser.co_ownership}
        name='co_ownership'
        onChange={() => dispatch(updateOnboardedUser({ ...onboardedUser, co_ownership: !onboardedUser.co_ownership }))}
      />

      {onboardedUser.co_ownership &&
        <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
          <SelectInput
            name='co_ownership_kind'
            label='Catégorie'
            options={allCoOwnershipKinds}
            selectedOption={allCoOwnershipKinds.find(option => option.value === onboardedUser.co_ownership_kind) || null}
            handleChange={(option) => handleKindSelect(option)}
            errors={errors}
          />

          <TextInput
            label='Raison sociale ou nom'
            name='co_ownership_name'
            value={onboardedUser.co_ownership_name}
            onChange={handleNameChange}
            errors={errors}
          />
        </div>
      }
    </div>
  );
}

export default CoOwnershipInput;
